import { render, staticRenderFns } from "./AdvancedPromotions.vue?vue&type=template&id=c5fec79c&scoped=true&"
import script from "./AdvancedPromotions.vue?vue&type=script&lang=js&"
export * from "./AdvancedPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fec79c",
  null
  
)

export default component.exports